import { connect } from 'react-redux'
import MasculineSpan from './MasculineSpan'
import { replaceText } from '../../actions/editor'


const mapStateToProps = state => {
    return {
        user: state.user,
    }
}

const mapDispatchToProps = dispatch => ({
    replaceText: editorState => {
        dispatch(replaceText(editorState))
    },
})

const MasculineSpanContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(MasculineSpan)

export default MasculineSpanContainer
